var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SportModel } from "../../../model";
import { liveStreamingMode } from "../../..";
var LiveStreamingBaseRetriever = /** @class */ (function () {
    function LiveStreamingBaseRetriever(gateway, dict, refreshInterval, liveStreamingMode) {
        this.streamingId = "streaming";
        this.gateway = gateway;
        this.dict = dict;
        this.refreshInterval = refreshInterval;
        this.liveStreamingMode = liveStreamingMode;
        this.isActive = false;
        this.liveStreamingRefreshTimer = -1;
    }
    LiveStreamingBaseRetriever.prototype.activate = function () {
        this.isActive = true;
    };
    LiveStreamingBaseRetriever.prototype.refresh = function (state, requestFactory) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.clearTimeout(this.liveStreamingRefreshTimer);
                return [2 /*return*/, this.refreshInternal(state, requestFactory)];
            });
        });
    };
    LiveStreamingBaseRetriever.prototype.refreshInternal = function (state, requestFactory) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = requestFactory();
                        return [4 /*yield*/, this.getCount(request)];
                    case 1:
                        response = _a.sent();
                        if (this.isActive) {
                            response && this.updateLiveStreaming(state, response);
                            if (this.refreshInterval > 0) {
                                this.liveStreamingRefreshTimer = window.setTimeout(function () { return _this.refreshInternal(state, requestFactory); }, this.refreshInterval);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LiveStreamingBaseRetriever.prototype.getCount = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.gateway.getCountByTag(request)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LiveStreamingBaseRetriever.prototype.updateLiveStreaming = function (state, data) {
        var eventsCount = data.events ? data.events : 0;
        if (eventsCount > 0) {
            var liveStreamingItem = state.getItemById(this.streamingId);
            if (liveStreamingItem) {
                state.update(this.streamingId, { numberOfEvents: eventsCount });
            }
            else {
                state.add(this.getStreamingItem(eventsCount));
            }
        }
        else {
            state.remove(this.streamingId);
        }
    };
    LiveStreamingBaseRetriever.prototype.getStreamingItem = function (numberOfEvents) {
        return new SportModel({
            id: this.streamingId,
            name: this.dict.streaming,
            numberOfEvents: numberOfEvents,
            order: this.getStreamingItemOrder()
        }, "liveStream");
    };
    LiveStreamingBaseRetriever.prototype.getStreamingItemOrder = function () {
        switch (this.liveStreamingMode) {
            case liveStreamingMode.firstSelected:
            case liveStreamingMode.first: return -1;
            case liveStreamingMode.last: return 1000;
        }
    };
    LiveStreamingBaseRetriever.prototype.deactivate = function () {
        this.isActive = false;
        window.clearTimeout(this.liveStreamingRefreshTimer);
    };
    return LiveStreamingBaseRetriever;
}());
export { LiveStreamingBaseRetriever };
//# sourceMappingURL=LiveStreamingBaseRetriever.js.map